import cn from 'classnames';
import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useMixpanel } from 'react-mixpanel-browser';

import { AnalyticsItemBox } from './AnalyticsItemBox';
import { BestSellersByChannels } from '../../graphs/BestSellersByChannels';

import { prepareDataForBestSellersGraph } from '../../../utils/analytics';
import { analyticsTopSellersUtils } from '../../../utils/analytics/top-sellers.utils';
import { REPORT_TYPES } from '../../tables/reports/consts';
import { AnalyticsOrderType } from '../../../constants/analytics';
import { reportBusinessActionToMixpanel } from '../../../utils/reportBusinessActionToMixpanel';

import styles from '../../graphs/graph.module.scss';

export function BestSellersByChannelsContainer() {
  const {
    metricsDataType: { 'best-sellers-by-channel': currentMetric },
    currentCurrency,
    currentOrderType,
    retailerNamesByIds,
    ui: {
      loading: { [REPORT_TYPES.BEST_SELLERS]: dataLoading, countries: countriesLoading, retailers: retailersLoading },
    },
    additionalData: {
      [REPORT_TYPES.BEST_SELLERS]: { data: bestSellersData },
    },
  } = useSelector((state) => state.analytics);
  const isGmvMetric = currentOrderType === AnalyticsOrderType.SALES;

  const dataKey = analyticsTopSellersUtils.getDataKeyFromCurrentOrderType(currentOrderType);

  let data = {};
  let keys = [];

  if (!isEmpty(bestSellersData)) {
    const response = prepareDataForBestSellersGraph({
      rawData: bestSellersData,
      currentCurrency: currentCurrency,
      metricsDataType: currentMetric,
      retailerNamesByIds,
    });
    data = response.uiData;
    keys = response.keys;
  }
  const mixpanel = useMixpanel();

  useEffect(() => {
    reportBusinessActionToMixpanel(mixpanel, 'sales-dashboard-best-sellers-by-channels-graph', {
      chosenValue: currentMetric,
    });
  }, [currentMetric, mixpanel]);

  const title = analyticsTopSellersUtils.getTitle(data?.[dataKey]);

  const loading = dataLoading || countriesLoading || retailersLoading || !bestSellersData;
  if (loading) {
    return (
      <AnalyticsItemBox title={title} largeSize showLoader={true}>
        <div className={cn(styles.graphWrapper, styles.barGraph)} />
      </AnalyticsItemBox>
    );
  }

  return (
    <BestSellersByChannels
      title={title}
      data={data}
      uiDataKey={dataKey}
      metric="best-sellers-by-channel"
      keys={keys}
      isGmvMetric={isGmvMetric}
      currency={currentCurrency}
    />
  );
}
